module.exports = __webpack_public_path__ + "media/images/front/services/design-3458cb13544b13c312b3c47959c48958.webp";